<template>
  <div class="homeContainer">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      style="min-height: 100vh"
    >
      <div class="header">
        <div class="userInfo">
          <div class="img" @click="toUserInfo" />
          <!-- <img src="../../assets/touxiang.png" style="width: 19.733vw;height: 21.333vw;" alt="" @click="toUserInfo"> -->
          <div class="userName">
            {{ userInfo.userName }}
          </div>
          <div class="userCode">学号：{{ userCode }}</div>
          <!-- <div class="message" @click="toMessage">
            <SvgIcon icon-class="iconxiaoxi"/>
            <span/>
          </div> -->
        </div>
        <div class="growNav">
          <div class="title">
            成长导航
          </div>
          <div class="nav">
            <div class="navItem" @click="toObjectives">
              <SvgIcon icon-class="iconicon3" />
              <div>
                培养目标
              </div>
            </div>
            <div class="navItem" @click="toGraduationRequirements">
              <SvgIcon icon-class="iconicon2" />
              <div>
                毕业要求
              </div>
            </div>
            <div class="navItem" @click="toCourseSystem">
              <SvgIcon icon-class="iconicon1" />
              <div>
                课程体系
              </div>
            </div>
            <!-- <div class="navItem" @click="toPost">
              <SvgIcon icon-class="iconicon"/>
              <div>岗位分析</div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="growRecord">
        <div class="title">
          成长记录
        </div>
        <div class="nav">
          <div class="navItem" @click="jumpAchieving">
            <div>
              课程达成记录
            </div>
          </div>
          <div class="navItem" @click="jump">
            <div>
              能力成长记录
            </div>
          </div>
          <div class="navItem" @click="jumpWarning">
            <img
              src="../../assets/chengzhang03.png"
              alt=""
              style="width:100%;height:100%;"
            />
            <div>
              能力预警记录
            </div>
          </div>
        </div>
      </div>
      <div class="growEvaluate">
        <div class="title">
          成长评价
        </div>
        <div class="tabBar">
          <div class="tabBarItem">
            未完成问卷
            <div />
            <span v-if="questionnaireCount">{{ questionnaireCount }}</span>
          </div>
          <div class="tabBarItem" @click="jumpComplete">
            历史问卷
          </div>
        </div>
        <div class="questionnaire">
          <div
            class="questionnaireItem"
            v-for="(item, index) in questionnaireData"
            :key="index"
          >
            <div class="questionnaireTitle">
              {{ item.form_name }}
            </div>
            <div class="questionnaireTime">
              起止时间：{{
                (item.startTime | time) + " - " + (item.entTime | time)
              }}
            </div>
            <div class="startQuestionnaire" @click="toAnswer(item.formId)">
              开始答卷
              <div class="img" />
            </div>
          </div>
        </div>
        <div class="viewAll" @click="jump1" v-if="questionnaireData.length">
          查看全部 >
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import api from "@/api";
import { PullRefresh } from "vant";
import { formatDate } from "@/utils/utils";
export default {
  name: "Home",
  components: {
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      questionnaireData: [],
      isLoading: false,
      userInfo: {},
      questionnaireCount: 0,
      userCode: ""
    };
  },
  filters: {
    time(val) {
      return val ? formatDate(val, "yyyy-MM-dd") : "";
    }
  },
  created() {
    this.userCode = localStorage.getItem("userCode");
  },
  mounted() {
    this.getUserInfo();
    this.getQuestionaire();
  },
  methods: {
    logout() {
      this.$get(api.userInfo.logout()).then(res => {
        if (res.status === 1) {
          localStorage.removeItem("x_token");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("userCode");
          localStorage.removeItem("claimId");
          localStorage.removeItem("claimCode");
          localStorage.removeItem("claimName");
          // this.$toast({
          //   message: "退出成功!",
          //   duration: 1000,
          //   position: 'bottom'
          // })
          this.$router.push({
            path: "/login"
          });
        } else {
          this.$toast({
            message: res.message,
            duration: 1000,
            position: "bottom"
          });
        }
      });
    },
    getUserInfo() {
      this.$get(api.home.userInfo()).then(res => {
        if (res.status === 1) {
          this.userInfo = res.data;
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        } else if (res.status === 0) {
          this.$toast({
            message: res.message,
            duration: 1000,
            position: "bottom"
          });
          this.logout();
        }
      });
    },
    getQuestionaire() {
      this.$post(api.questionnaire.listUnFinish(), {
        page: 1,
        rows: 1000
      }).then(res => {
        this.questionnaireCount = res.data.total;
        this.questionnaireData = res.data.list.slice(0, 3);
        // if(res.data.total > 3) {
        //   this.questionnaireData = res.data.list.slice(0, 2)
        // } else {
        //   this.questionnaireData = res.data.list
        // }
      });
    },
    onRefresh() {
      this.$get(api.home.userInfo()).then(res => {
        if (res.status === 1) {
          this.userInfo = res.data;
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          this.$post(api.questionnaire.listUnFinish(), {
            page: 1,
            rows: 1000
          }).then(res => {
            if (res.status === 1) {
              this.questionnaireCount = res.data.total;
              this.questionnaireData = res.data.list.slice(0, 2);
              this.$toast({
                message: "刷新成功",
                duration: 1000,
                position: "bottom"
              });
              this.isLoading = false;
            } else {
              this.$toast({
                message: "请刷新重试！",
                duration: 1000,
                position: "bottom"
              });
              this.isLoading = false;
            }
          });
        } else {
          this.$toast({
            message: "请刷新重试！",
            duration: 1000,
            position: "bottom"
          });
          this.isLoading = false;
        }
      });
    },
    toUserInfo() {
      this.$router.push({
        path: "/userInfo"
      });
    },
    toMessage() {
      this.$router.push({
        path: "/message"
      });
    },
    //  问卷查看更多
    jump1() {
      this.$router.push({
        path: "/myQuestionaire"
      });
    },
    //能力成长记录
    jump() {
      this.$router.push({
        path: "/abilityGrowthRecord"
      });
    },
    // 能力预警记录
    jumpWarning() {
      this.$router.push({
        path: "/capacityWarning"
      });
    },
    // 课程达成记录
    jumpAchieving() {
      this.$router.push({
        path: "/achievingCourses"
      });
    },
    toObjectives() {
      this.$router.push({
        path: "/objectives"
      });
    },
    toGraduationRequirements() {
      this.$router.push({
        path: "/graduationRequirements"
      });
    },
    toCourseSystem() {
      this.$router.push({
        path: "/courseSystem"
      });
    },
    toPost() {
      this.$router.push({
        path: "/post"
      });
    },
    //  开始答卷
    toAnswer(id) {
      this.$router.push({
        path: "/Questionnairefilling",
        query: {
          formId: id
        }
      });
    },
    // 历史问卷
    jumpComplete() {
      this.$router.push({
        path: "/MyQuestionaire",
        query: {
          index: 10
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.homeContainer {
  background-color: #fff;
  .header {
    padding: 68px 24px 10px;
    height: 610px;
    background: url("../../assets/bg-index.png") no-repeat;
    background-size: 100% 100%;
    .userInfo {
      overflow: hidden;
      margin-bottom: 60px;
      .img {
        margin-left: 46px;
        float: left;
        width: 148px;
        height: 160px;
        background-image: url("../../assets/touxiang.png");
        background-size: 100% 100%;
      }
      .userName {
        font-size: 36px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(12, 70, 80, 1);
        margin: 41px 0 10px 224px;
        letter-spacing: $letter-spacing;
      }
      .userCode {
        font-size: 22px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(12, 70, 80, 1);
        letter-spacing: $letter-spacing;
        margin-left: 224px;
      }
      .message {
        position: absolute;
        top: 126px;
        right: 63px;
        svg {
          width: 44px;
          height: 44px;
        }
        span {
          display: inline-block;
          position: absolute;
          top: -7px;
          right: -8px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          font-size: 20px;
          text-align: center;
          line-height: 32px;
          background-color: #f85959;
          color: #fff;
        }
      }
    }
    .growNav {
      width: 100%;
      height: 282px;
      background-color: #fff;
      box-shadow: $box-shadow;
      border-radius: 40px;
      overflow: hidden;
      padding: 0 60px;
      .title {
        text-align: center;
        font-size: 30px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(50, 50, 50, 1);
        letter-spacing: $letter-spacing;
        margin-top: 29px;
      }
      .nav {
        margin-top: 53px;
        display: flex;
        .navItem {
          flex: 1;
          margin: 0 30px;
          &:first-of-type {
            margin-left: 0;
          }
          &:last-of-type {
            margin-right: 0;
          }
          svg {
            width: 80px;
            height: 75px;
            margin: 0 auto;
            display: block;
          }
          div {
            font-size: 22px;
            font-family: PingFangSC;
            font-weight: 700;
            color: rgba(50, 50, 50, 1);
            margin-top: 20px;
            text-align: center;
          }
        }
      }
    }
  }
  .growRecord {
    // margin-top: 10px;
    padding: 0 24px;
    width: 100%;
    background-color: #fff;
    overflow: hidden;
    .title {
      text-align: center;
      font-size: 30px;
      font-family: PingFangSC;
      font-weight: 600;
      color: rgba(50, 50, 50, 1);
      letter-spacing: $letter-spacing;
    }
    .nav {
      margin-top: 40px;
      display: flex;
      height: 160px;
      .navItem {
        position: relative;
        flex: 1;
        margin: 0 10px;
        height: 160px;
        background-image: url("../../assets/chengzhang02.png");
        background-size: 100% 100%;
        &:first-of-type {
          margin-left: 0;
          background-image: url("../../assets/chengzhang01.png");
          background-size: 100% 100%;
        }
        &:last-of-type {
          margin-right: 0;
          background-image: url("../../assets/chengzhang03.png");
          background-size: 100% 100%;
        }
        img {
          width: 220px;
          height: 160px;
        }
        div {
          font-size: 24px;
          font-family: PingFangSC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          position: absolute;
          left: 15px;
          top: 35px;
        }
      }
    }
  }
  .growEvaluate {
    margin-top: 40px;
    padding: 0 24px;
    width: 100%;
    background-color: #fff;
    overflow: hidden;
    padding-bottom: 30px;
    position: relative;
    .title {
      text-align: center;
      font-size: 30px;
      font-family: PingFangSC;
      font-weight: 600;
      color: rgba(50, 50, 50, 1);
      letter-spacing: $letter-spacing;
    }
    .tabBar {
      margin-top: 30px;
      font-size: 26px;
      font-family: PingFangSC;
      font-weight: 600;
      letter-spacing: $letter-spacing;
      display: flex;
      .tabBarItem {
        flex: 1;
        text-align: center;
        position: relative;
        height: 55px;
        &:first-of-type {
          color: $color-primary;
          div {
            width: 50px;
            height: 8px;
            background: $color-primary;
            border-radius: 4px;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
          span {
            position: absolute;
            top: 5px;
            right: 60px;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            font-size: 20px;
            text-align: center;
            line-height: 32px;
            background-color: #f85959;
            color: #fff;
          }
        }
        &:last-of-type {
          color: #969696;
        }
      }
    }
    .questionnaire {
      padding-bottom: 30px;
      .questionnaireItem {
        padding: 30px 30px;
        margin-top: 30px;
        height: 150px;
        background: rgba(255, 255, 255, 1);
        box-shadow: $box-shadow;
        border-radius: 10px;
        position: relative;
        .questionnaireTitle {
          font-size: 24px;
          font-family: PingFangSC;
          font-weight: 700;
          color: rgba(50, 50, 50, 1);
          letter-spacing: $letter-spacing;
        }
        .questionnaireTime {
          font-size: 20px;
          font-family: PingFangSC;
          font-weight: 400;
          color: #969696;
          margin-top: 25px;
        }
        .startQuestionnaire {
          height: 44px;
          line-height: 44px;
          font-size: 22px;
          font-family: PingFangSC;
          font-weight: 500;
          color: $color-primary;
          position: absolute;
          top: 53px;
          right: 30px;
          .img {
            display: inline-block;
            width: 44px;
            height: 44px;
            vertical-align: bottom;
            margin-left: 10px;
            background-image: url("../../assets/kaishidajuan.png");
            background-size: 100% 100%;
          }
        }
      }
    }
    .viewAll {
      width: 240px;
      height: 60px;
      box-shadow: $box-shadow;
      border-radius: 10px;
      font-size: 20px;
      font-family: PingFangSC;
      font-weight: 500;
      line-height: 60px;
      text-align: center;
      color: #969696;
      margin: 0 auto;
    }
  }
}
</style>
